export const TEXTS = {
    INCOGNITO_TURN_ON: "Turn on incognito mode",
    INCOGNITO_TURN_OFF: "Turn off incognito mode",
    MENU_OPTIONS_ARIA_LABEL: "More options",
};
